import * as moment from 'moment';
import  flatpickr  from 'flatpickr';
import  { German } from 'flatpickr/dist/l10n/de';
import  { Dutch } from 'flatpickr/dist/l10n/nl';
import  { French } from 'flatpickr/dist/l10n/fr';
import  { Spanish } from 'flatpickr/dist/l10n/es';
import  { Portuguese } from 'flatpickr/dist/l10n/pt';

//prime the flatpickr locales that you want to support; English already present
flatpickr.localize(Dutch);
flatpickr.localize(German);
flatpickr.localize(French);
flatpickr.localize(Portuguese);
flatpickr.localize(Spanish);

export let getDateTimeFormat = ( options?: Intl.DateTimeFormatOptions  ): Intl.DateTimeFormat => new Intl.DateTimeFormat(navigator.language, options);
export let dateSeparatorSymbol: string = undefined;
export let timeSeparatorSymbol: string = undefined;
export let subSecondSeparatorSymbol: string = undefined;
  
export const localize = (language:string ) => {
    let flatpickrLocaleKey  = <flatpickr.Options.LocaleKey>language.substr(0,2).toLowerCase();
    flatpickr.localize(flatpickr.l10ns[ flatpickrLocaleKey ]);
    moment.locale(language);
    getDateTimeFormat = (options?: Intl.DateTimeFormatOptions) => new Intl.DateTimeFormat(language,options);
    localizeDateTimeSeperatorSymbols();
}

//Works only with decimal notations
const localizeDateTimeSeperatorSymbols = () => {
  dateSeparatorSymbol = getDateTimeFormat({ 
  year:'numeric', 
  month:'numeric', 
  timeZone:'utc' }).format(0).replace( /[0-9.]/g, '' );
  
  timeSeparatorSymbol = getDateTimeFormat({ 
  hour:'numeric', 
  minute:'numeric', 
  timeZone:'utc' }).format(0).replace( /[0-9.]/g, '' );
  
  subSecondSeparatorSymbol = getDateTimeFormat({ 
  second:'numeric', 
  fractionalSecondDigits: 3, 
  timeZone:'utc' }).format(0).replace( /[0-9.]/g, '' );
}

localizeDateTimeSeperatorSymbols();